import React from "react";
import List from "../../shared/List";
import helpers from "../../shared/helpers";
import config from "../../config";
import Popup from "../../shared/Popup";
import Form from "../../shared/Form";
import {eventLink,eventEditLink} from "./helpers";
import {ajaxPOST,ajaxGET} from "../../ajax";


export default function EventList({type,slug,title,limit,titleLink,island,query,active,key}){

  const [showPopup,setShowPopup] = React.useState(false);
  const [actionSuccess,setActionSuccess] = React.useState(false);
  const [actionLoading,setActionLoading] = React.useState(false);
  const [focusItem,setFocusItem] = React.useState(false);
  const [focusItemDetails,setFocusItemDetails] = React.useState(false);
  const [optionItem,setOptionItem] = React.useState(false);
  const [updateData,setUpdateData] = React.useState(false);
  const [showForm,setShowForm] = React.useState(false);
  const [selected,setSelected] = React.useState([]);
  const checkboxRef = React.useRef([]);
  const [showDeclinePopup,setShowDeclinePopup] = React.useState(false);
  const [declineItem,setDeclineItem] = React.useState(false);
  const [declineBulk,setDeclineBulk] = React.useState(false);
  const [declineMessage,setDeclineMessage] = React.useState("");
  const [declineCc,setDeclineCc] = React.useState("");
  const [declineLoading,setDeclineLoading] = React.useState(false);

  const hidePopup = () => {
    setShowPopup(false);
    setActionLoading(false);
    setActionSuccess(false);
    setOptionItem(false);
  };

  const showOptions = (item) => {
    setOptionItem(item);
    setShowPopup(true);

  };


  React.useEffect(()=>{
    console.log(selected);
  },[selected]);


  const rowAction = async (action,data,loading) => {
    setActionLoading(loading);
    var result = await ajaxPOST(config.events.API_DOMAIN+action,data);

    setActionSuccess(result.message);
    if(action == "delete" || action == "approve"){
      setUpdateData({
        key:'eventHash',
        keyValue:data.eventHash,
        newData:"delete"
      });
    }
    return result;
  };

  const hideDeclinePopup = () => {
    setShowDeclinePopup(false);
    setDeclineItem(false);
    setDeclineBulk(false);
    setDeclineMessage("");
    setDeclineCc("");
    setDeclineLoading(false);
  };

  const showDecline = (item, bulk=false) => {
    setDeclineItem(item);
    setDeclineBulk(bulk);
    setDeclineMessage("");
    setDeclineCc("");
    setShowDeclinePopup(true);
  };

  const confirmDecline = async () => {
    setDeclineLoading("Declining Event Listing");
    const items = declineBulk ? selected : [declineItem];
    for(const item of items){
      await ajaxPOST(config.events.API_DOMAIN+"delete",{
        eventHash:item.eventHash,
        slug:slug,
        declineMessage:declineMessage,
        declineCc:declineCc
      });
      setUpdateData({
        key:'eventHash',
        keyValue:item.eventHash,
        newData:"delete"
      });
    }
    if(declineBulk){
      setSelected([]);
    }
    hideDeclinePopup();
  };

  const deleteAction = (item, loadingText) => {
    if(type === "pending" || item.approved !== true){
      showDecline(item);
    }
    else{
      rowAction("delete",{eventHash:item.eventHash,slug:slug},loadingText);
    }
  };

  /*
Free Comic Book Day @ Kihei Public Library
Sat, May 4, 2024
Approve Event	maui	

	GUITAR NIGHT Slack Key & Fingerstyle Guitar
Sat, May 18, 2024
Approve Event	big-island	

	Henry Kaponos Artist2Artist Concert & Kalae Parish, Kalenaku, Pat
Fri, May 3, 2024
big-island
  */

  React.useEffect(async ()=>{
    if(focusItem === false) return;
    var result = await ajaxGET(config.events.API_DOMAIN+"get",{'eventHash':focusItem.eventHash,'slug':slug});
    if(result){
      setFocusItemDetails(result);
    }
  },[focusItem]);

  React.useEffect(async ()=>{
    if(optionItem === false) return;

  },[showForm]);

  const selectAll = () => {
    checkboxRef.current.forEach((c)=>{
      if(!c.checked){
        c.click();
      }
    })
  }

  const selectNone = () => {
    setSelected([]);
  }

  const multipleApprove = () => {
    selected.forEach(s=>{
      rowAction("approve",{eventHash:s.eventHash})
    });
  }
  const multipleDelete = () => {
    if(type === "pending"){
      showDecline(selected[0], true);
      return;
    }
    selected.forEach(s=>{
      rowAction("delete",{eventHash:s.eventHash})
    });
  }

  var urlGET = `${config.events.API_DOMAIN}${type}${island ? `?island=${island}` : ``}`;
  if(query && query !== ""){
    urlGET = `${config.events.API_DOMAIN}search?query=${query}${island ? `&island=${island}` : ``}${active ? `&active=true` : ``}`
  }

  return (<>


    <Popup
     show={showDeclinePopup}
     hide={hideDeclinePopup}
     style={{width:"500px"}}>
     {declineLoading ?
       (<center>{declineLoading}</center>) : (<>
         <b style={{display:"block",textAlign:"center",paddingBottom:10}}>{declineBulk ? `Decline ${selected.length} Events` : declineItem.title}</b>
         <label style={{display:"block",textAlign:"left",fontSize:"12px",textTransform:"uppercase",letterSpacing:"1px",marginBottom:"5px"}}>
           Decline Message (optional)
           <textarea
             style={{display:"block",width:"100%",minHeight:"120px",marginTop:"5px",padding:"10px",boxSizing:"border-box",fontSize:"14px"}}
             value={declineMessage}
             onChange={(e)=>setDeclineMessage(e.target.value)}
             placeholder="Explain why this event was declined..."
           />
         </label>
         <label style={{display:"block",textAlign:"left",fontSize:"12px",textTransform:"uppercase",letterSpacing:"1px",marginBottom:"15px",marginTop:"15px"}}>
           CC (optional)
           <input
             type="text"
             style={{display:"block",width:"100%",marginTop:"5px",padding:"10px",boxSizing:"border-box",fontSize:"14px"}}
             value={declineCc}
             onChange={(e)=>setDeclineCc(e.target.value)}
             placeholder="email@example.com, another@example.com"
           />
         </label>
         <ul className="optionsList">
          <li onClick={confirmDecline}>Decline Event{declineBulk ? "s" : ""}</li>
          <li onClick={hideDeclinePopup} className="cancel">Cancel</li>
         </ul>
       </>)}
    </Popup>

    <Popup
     show={showPopup}
     hide={hidePopup}>
     {actionLoading ?
       (<>
         {actionSuccess ? (<>
           <center>{actionSuccess}</center>
           <ul className="optionsList">
            <li onClick={hidePopup}>OK</li>
           </ul>
         </>) : (<center>{actionLoading}</center>)}
       </>) : (<>
         <b style={{display:"block",textAlign:"center",paddingBottom:10}}>{optionItem.title}</b>         
        <ul className="optionsList">
          {(focusItem.active !== "true") && (<li onClick={()=>rowAction("approve",{'eventHash':optionItem.eventHash,'slug':slug},"Approving Event Listing")} className="">Approve Event</li>)}
          <li onClick={()=>{ hidePopup(); deleteAction(optionItem, type === "pending" ? "Declining Event Listing" : "Deleting Event"); }} className="">{type === "pending" ? "Decline Event" : "Delete Event"}</li>
          <li onClick={()=>window.open(eventEditLink(optionItem))}>Edit Event</li>

          <li onClick={hidePopup} className="cancel">Cancel</li>
         </ul>
       </>)}
    </Popup>

    <Popup
      show={focusItem}
      hide={()=>{ setFocusItem(false); setFocusItemDetails(false); }}
    >
      <div className="details">
        {focusItem.image && (<img src={focusItem.image}/>)}
        {focusItem.featured ? (<><b>FEATURED</b><br/></>) : (<></>)}
        <h2 style={{marginBottom:0,paddingBottom:0}}>{focusItem.title}</h2>
        <center>
          {focusItem.approved !== true && <button className="button2" onClick={()=>{ showOptions(focusItem); setFocusItem(false); rowAction("approve",{'eventHash':focusItem.eventHash},"Approving Event Listing"); }}>Approve</button>}
          <button className="button2 red" onClick={()=>{ setFocusItem(false); deleteAction(focusItem, type === "pending" ? "Declining Event Listing" : "Removing Event Listing"); }}>{type === "pending" ? "Decline" : "Remove"}</button>
          <button className="button2" onClick={()=>{ window.open(eventEditLink(focusItem)) }}>Edit</button>
        </center>

        {focusItem.dates && focusItem.dates.map(d=>(
          <div className="line">{d.dateString} {d.timeString}</div>
        ))}

        <div className="section">
          <b>Submitted By</b>
          <span><a href={`mailto:${focusItem.userEmail}`}>{focusItem.userEmail}</a></span>
        </div>
        <div className="section">
          <b>Description</b>
          <span dangerouslySetInnerHTML={{__html:focusItem.description}}></span>
        </div>

        <div className="section">
          <b>Location</b>
          {focusItem.address}
        </div>

        <div className="section">
          <b>Category</b>
          {focusItem.category && focusItem.category.replace(/,/g,", ")}
        </div>


      </div>

    </Popup>


    <List
      title={title}
      titleLink={titleLink}
      limit={limit}
      key={key}
      multiple={type == "pending" ? true : false}
      multipleOptions={(<>
        <button onClick={selectAll}>Select All</button>
        <button onClick={selectNone}>Select None</button>
        <button style={{marginLeft:"20px"}} onClick={multipleApprove}>Approve Selected</button>
        <button style={{marginLeft:"20px"}} onClick={multipleDelete}>{type === "pending" ? "Decline Selected" : "Delete Selected"}</button>
        
      </>)}
      selected={selected}
      setSelected={setSelected}
      emptyMessage={(<div style={{display:"block",padding:"30px 10px 30px 10px",textAlign:"center",textTransform:"uppercase"}}>No {type} Events</div>)}
      updateData={updateData}
      urlGET={urlGET}
      template={(i,index)=>{
        return (
          <tr key={`item${index}`}>
            {type == "pending" ? (<>
              <td style={{width:"20px"}}>
                <input ref={(r)=>{ checkboxRef.current[index] = r; }} type="checkbox" checked={selected.includes(i)} onChange={(e)=>{
                  if(e.target.checked){
                    setSelected(s=>([...s,i]));
                  }
                  else{
                    setSelected(selected.filter(s=>(s !== i)));
                  }
                  
                }}/>
              </td>
            </>) : (<></>)}
            <th onClick={()=>setFocusItem(i)} style={{textDirection:"underline"}}>
              {i.title}
            <div style={{fontWeight:"normal"}}>{i.dates.map(d=>{
              return (<>{d.dateString}<br/></>)
            })}</div>
            </th>
            {type == "pending" ? (<td><a href="#" onClick={()=>rowAction("approve",{'eventHash':i.eventHash,'slug':i.calendarID},"Approving Event Listing")} className="">Approve Event</a></td>) : (<></>)}
            <td>{i.calendarID}</td>
            <td style={{minWidth:"50px"}}>
              <div className="options" onClick={()=>showOptions(i)}>
                <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Ellipsis Vertical Circle</title><circle fill="currentColor"  cx="256" cy="256" r="26"/><circle fill="currentColor" cx="256" cy="346" r="26"/><circle cx="256" cy="166" fill="currentColor"  r="26"/><path d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"/></svg>
              </div>
            </td>
          </tr>
        )
      }}
    />
  </>);
}
